export const faqs = [
  {
    q: "Where are your properties located?",
    a: "Our suites and homes are in Wilton Manors and Fort Lauderdale, Florida — walkable to Wilton Drive's cafés and nightlife, and a short drive from the beaches.",
  },
  {
    q: "How do I book a stay?",
    a: "Every property links straight to our secure Hospitable Direct booking page, where you can check live availability, see rates and reserve instantly. Look for the 'Book' button on any property.",
  },
  {
    q: "What is check-in and check-out?",
    a: "Check-in is from 4:00 PM and check-out is by 11:00 AM. All of our homes offer contactless self check-in — we'll send your door code and a welcome guide before you arrive.",
  },
  {
    q: "Are early check-ins or late check-outs available?",
    a: "Yes, depending upon availability and for a small fee to accommodate the rescheduling of room cleaning. This option will be shown if available in the guest portal after booking.",
  },
  {
    q: "Are pets allowed?",
    a: "We love welcoming the whole family—including the furry, four-legged members! 🐾❤️ All four Double Rainbow Suites homes are pet friendly — dogs and cats are always welcome, with no restrictions. A small pet fee applies per pet, per stay and varies a little by home; the exact amount is always shown at checkout before you book, so there are never surprises on arrival. Just add your furry family member to your reservation, and we'll be ready with a warm Double Rainbow welcome! 🌈🐶🐱",
  },
  {
    q: "Is there parking?",
    a: "Yes — free parking is available at all of our properties, and our Wilton Manors homes at 1425 NE 24th St also have a Level 2 EV charger, free for guests. Details are included in your welcome guide after booking.",
  },
  {
    q: "Do you offer long-term or monthly stays?",
    a: "We do accommodate longer stays and often have monthly rates. Reach out through our contact page with your dates and we'll put together an offer.",
  },
  {
    q: "What is your cancellation policy?",
    a: "Cancellation terms are shown at the time of booking on each property's reservation page. Policies can vary by property and season, so please review them before you confirm.",
  },
  {
    q: "Double Rainbow Suites also offers co-hosting for property owners.",
    a: "Own a place in the Fort Lauderdale or Wilton Manors area and want a trusted, hands-on co-host? Double Rainbow Suites supports owners with hospitality-focused co-hosting — listings, pricing, guest experience and turnovers — a flexible alternative to traditional property management where you stay the host of record.",
    cta: { label: "Tell us about your property", to: "/property-management" },
  },
];
